import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import "./../UI Component/Modal/Modal.css";
import swal from "sweetalert";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import Spinner from "react-bootstrap/Spinner";
import "./styles.scss";
import Cancel from "./cancellation.png";
import SuccessCancellationModal from "./success-cancellation-modal";
import {
  disableHelpButton,
  enableHelpButton,
} from "../common/DisableHelpButton/DisableHelpButton";
import Loader from "../UI Component/Loader/Loader";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";

const CancellationModal = (props) => {
  const [cancellationMessage, setCancellationMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  const yesClickHandler = () => {
    setPageLoader(true);
    let params = {
      appointment_id: props.appointment_id,
      doctor_id: props?.doctorId ? props?.doctorId : userId,
    };
    if (staffId) {
      params["staff_id"] = staffId;
    }
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/cancel-appointment-confirmation-rev1",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        ...params,
      },
    })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.statusCode === 200) {
            setPageLoader(false);
            setShowSuccessModal(true);

            // swal({
            //   title: "Success!!",
            //   text: response.data.message,
            //   icon: "success",
            //   button: "Okay",
            // });
          } else {
            setPageLoader(false);
            swal({
              title: "Unable to cancel appointment",
              text: response.data.message,
              icon: "warning",
              button: "Okay",
            });
          }
        }
      })
      .catch((e) => {
        swal({
          title: "Unable to cancel appointment",
          icon: "warning",
          button: "Okay",
        });
      });
  };

  useEffect(() => {
    if (props.openView) {
      disableHelpButton();
      setLoading(true);
      cancelAppointment();
    }
    return () => {
      enableHelpButton();
    };
  }, [props.openView]);

  function cancelAppointment() {
    let params = {
      appointment_id: props.appointment_id,
      doctor_id: props?.doctorId ? props?.doctorId : userId,
    };
    if (staffId) {
      params["staff_id"] = staffId;
    }
    afterLoginApiAxios({
      method: "post",
      url: "/public/cancel-appointment-request-rev1",
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        ...params,
        reason: "Testing",
      },
    })
      .then((response) => {
        setLoading(false);
        if (response.status == 200) {
          if (response.data.statusCode === 200) {
            setCancellationMessage(response.data.message);
          } else {
            swal({
              title: "Unable to cancel appointment",
              text: response.data.message,
              icon: "IN",
              button: "Okay",
            });
          }
        }
      })
      .catch((e) => {
        setLoading(false);
        swal({
          title: "Something went wrong",
          icon: "error",
          button: "Okay",
        });
      });
  }

  const getRefundAmount = () => {
    if (cancellationMessage == false) return null;
    return cancellationMessage
      .toString()
      .split("Rs.")[1]
      .toString()
      .split(",")[0];
  };

  const closeModal = () => {
    props.closeView();
  };

  return (
    <>
      {pageLoader ? (
        <Loader />
      ) : (
        <>
          {props.openView ? (
            <Modal show={props.openView} onHide={props.closeView} centered>
              <Modal.Body>
                <div className="d-flex align-items-center justify-content-end w-100 px-4 pt-2 pb-3">
                  <div onClick={closeModal} className="cursor-pointer">
                    Close X
                  </div>
                </div>
                <div className="cancellation-popup">
                  <div className="d-flex align-items-center justify-content-center flex-column p-4">
                    {loading ? (
                      <Spinner animation="border" variant="secondary" />
                    ) : (
                      <>
                        <div>
                          <img src={Cancel} />
                        </div>
                        <div className="reschedule-title title-width-controller">
                          Do you really want to cancel the appointment?
                        </div>
                        {cancellationMessage !=
                        "Do you really want to cancel an appointment?" ? (
                          <div className="reschedule-text text-center px-3 my-3">
                            On cancellation, your patient will be refunded Rs.{" "}
                            <b>{getRefundAmount()}</b>
                            <br />
                            Amount will be refunded only if you cancel 3 hours
                            before the consultation.
                            <br />
                            In case of any query, please contact our team at{" "}
                            <span className="pink-text">1800 267 9899.</span>
                          </div>
                        ) : null}
                        <div className="w-lg-50 w-sm-100 d-flex justify-content-lg-around justify-content-sm-center align-items-center flex-sm-column flex-lg-row">
                          <button
                            className="btn primary-cta-button rounded-pill mt-3 p-2 px-5 mx-lg-4"
                            onClick={() => {
                              closeModal();
                              yesClickHandler();
                              // props.refreshAppointmentsMethod();
                            }}
                          >
                            Yes
                          </button>
                          <button
                            className="btn secondary-button rounded-pill mt-3 p-2 px-5"
                            onClick={() => {
                              closeModal();
                              props.refreshAppointmentsMethod();
                              props.callNextAppointmentWidget &&
                                props.callNextAppointmentWidget();
                            }}
                          >
                            No
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          ) : null}

          <SuccessCancellationModal
            show={showSuccessModal}
            handleClose={() => {
              setShowSuccessModal(false);
              props.callNextAppointmentWidget &&
                props.callNextAppointmentWidget();
              props.refreshAppointmentsMethod();
            }}
          />
        </>
      )}
    </>
  );
};

export default CancellationModal;
